export default __webpack_public_path__ + "static/media/img-1.ad2db78c.jpg";